import React, {useState, useEffect} from 'react';
import { useHistory } from 'react-router-dom';
import "../../../css/footer.scss"
import Mappings from '../../actions/mappings';
import Cookies from 'js-cookie';


function Footer() {
    const history = useHistory();
    const footerOptions = ['aboutUs', 'help', 'contactUs', 'rs11Foundation', 'press', 'career', 'privacy', 'terms'];
    let userId = Cookies.get('rs11_user_id') ?? 0;
    
    const handleFooterPages = (i) => {
        if(i == 0) {
            history.push('/about-us')
        };
        if(i == 1){
            history.push('/help')
        };
        if(i == 3){
            history.push('/rs11-foundation')
        };
        if(i == 4){
            history.push('/press')
        };
        if(i == 5){
            history.push('/careers')
        };
        if(i == 6){
            history.push('/privacy-policy')
        };
        if(i == 7){
            history.push('/terms')
        };
    }


    return(
        <div className='footer'>
            <div className='navigate-pages'>
            {
                footerOptions.map((item, i) => {
                    return(
                        (item == 'contactUs') ? (
                        <a className='footer-text' href = "mailto:support@rs11.com?subject=RS11 Valuation">
                            Contact Us
                        </a>
                        ) : (
                        <p className='footer-text' key={i} onClick={() => handleFooterPages(i)}>
                            {Mappings[item]}
                        </p>
                        )
                    );
                })
            }
            </div>
        </div>
    )
}

export default Footer;
